import styled from 'styled-components';

export const QRContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  width: 100%;
`;

export const QRLoadingContainer = styled.div`
  width: 264px;
  height: 264px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const QRLoadingText = styled.p`
  text-align: center;
  color: #666;
`;

export const QRCodeDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-bottom: 16px;
`;

export const QRCodeImage = styled.img`
  width: 264px;
  height: 264px;
  margin: 0 auto;
`;

export const ProgressBarContainer = styled.div`
  width: 264px;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  position: relative;
  margin: 0 auto;
`;

export const ProgressBar = styled.div`
  width: ${({ percentage }) => percentage}%;
  height: 4px;
  background-color: ${({ countdown }) =>
    countdown > 20 ? '#2ec9b7' : '#ff2c3a'};
  border-radius: 2px;
  transition: width 1s linear, background-color 0.5s ease;
`;

export const CountdownTextContainer = styled.div`
  width: 264px;
  text-align: right;
`;

export const CountdownText = styled.p`
  font-size: 12px;
  color: #666;
`;

export const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const InstructionsText = styled.div`
  color: #3d3d3d;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  white-space: pre-line;
`;

export const SmallerInstructionsText = styled.div`
  margin-top: 4px;
  margin-left: 16px;
  color: #3d3d3d;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  white-space: pre-line;
`;
